import { Injectable } from '@angular/core';

import { GraphqlService } from '@shared/services/http/graphql.service';

import gql from 'graphql-tag';

@Injectable({ providedIn: 'root' })
export class PromotionService {
  private applyPromotionCodeMutation = gql`mutation applyPromotionCode($code: String!) {
  applyPromotionCode(data: {signupPromotionCode: $code}) {
    message
  }
}`;

  constructor(
    private graphqlService: GraphqlService,
  ) { }

  async applyPromotionCode(variables: { code: string }): Promise<{ message: string }> {
    return this.graphqlService.mutate(this.applyPromotionCodeMutation, variables)
      .then(data => data.applyPromotionCode);
  }

}
